import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { CheckItem, createCheckListFormInput, createEmptyCheckListFormInput } from '@rpe/registro-personas-empresas-lib';
import { Observable, of } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../core/core.module';
import { Especie } from '../../entity-especies/especies.model';
import { selectAllEspecies } from '../../entity-especies/especies.selectors';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { AnalisisLaboratorioEspecie, AuxFormAnalisisLaboratorioEspecie, createAnalisisLaboratorioEspecie } from '../../entity-analisis-especie-laboratorio/analisis-laboratorio-especie.model';
import { Balanza, createBalanza } from '../../entity-balanzas/balanzas.model';
import { createDivisorMuestra, DivisorMuestra } from '../../entity-divisores-muestra/divisores-muestra.model';
import { selectDivisoresMuestraCheckList } from '../../entity-divisores-muestra/divisores-muestra.selectors';
import { createEquipamientoLaboratorio, EquipamientoLaboratorio } from '../../entity-equipamientos-laboratorio/equipamientos-laboratorio.model';
import { selectEquipamientosLaboratorioCheckList } from '../../entity-equipamientos-laboratorio/equipamientos-laboratorio.selectors';
import { createGerminador, Germinador } from '../../entity-germinadores/germinadores.model';
import { createEmptyEquipamiento, createEmptyLaboratorioFormInput, Equipamiento, EquipamientoFormInput, LaboratorioFormInput } from '../../entity-laboratorios/laboratorios.model';
import { TipoAnalisisLaboratorio } from '../../entity-tipos-analisis-laboratorio/tipos-analisis-laboratorio.model';
import { selectAllTiposAnalisisLaboratorio } from '../../entity-tipos-analisis-laboratorio/tipos-analisis-laboratorio.selectors';
import { TipoDivisorMuestra } from '../../entity-tipos-divisor-muestra/tipos-divisor-muestra.model';
import { selectAllTiposDivisorMuestra } from '../../entity-tipos-divisor-muestra/tipos-divisor-muestra.selectors';
import { TipoEquipamientoLaboratorio } from '../../entity-tipos-equipamiento-laboratorio/tipos-equipamiento-laboratorio.model';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'rpe-registro-actividad-laboratorio-equipamiento-form',
  templateUrl:
    './registro-actividad-laboratorio-equipamiento-form.component.html',
  styleUrls: [
    './registro-actividad-laboratorio-equipamiento-form.component.scss'
  ]
})
export class RegistroActividadLaboratorioEquipamientoFormComponent implements OnInit {
  
  @Input()
  set formInput(equipamientoFormInput: EquipamientoFormInput) {
    if (equipamientoFormInput != null) {
      this._equipamiento = equipamientoFormInput.equipamiento;
      this.setValues(this._equipamiento);
    }
    // Divisor muestra
    this.tiposDivisorMuestraCheckItemList$ = this.store.select(
      selectDivisoresMuestraCheckList(equipamientoFormInput.laboratorioId)
    );
    this.tiposDivisorMuestraCheckItemList$.subscribe((lci) => {
      this.formInputDivisorMuestra = createEmptyCheckListFormInput();
      this.formInputDivisorMuestra.elementosCheck = lci;
    });

    // Equipamientos Laboratorios
    this.tiposEquipamientoLaboratorioCheckItemList$ = this.store.select(
      selectEquipamientosLaboratorioCheckList(
        equipamientoFormInput.laboratorioId
      )
    );
    this.tiposEquipamientoLaboratorioCheckItemList$.subscribe((lci) => {
      this.formInputEquiposLaboratorio = createEmptyCheckListFormInput();
      this.formInputEquiposLaboratorio.elementosCheck = lci;
    });
  }
  get formInput(): EquipamientoFormInput {
    return null;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Equipamiento>();

  _formInput: LaboratorioFormInput = createEmptyLaboratorioFormInput();
  formInputAnalisisLaboratorio = createEmptyCheckListFormInput();
  formInputDivisorMuestra = createEmptyCheckListFormInput();
  formInputEquiposLaboratorio = createEmptyCheckListFormInput();

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  equipamientoFormGroup = this.fb.group({
    balanzas: this.fb.array([]),
    germinadores: this.fb.array([]),
    divisores_muestra: this.fb.group({}),
    equipos: this.fb.group({}),
    analisis_especie: this.fb.array([]),
    otherEquipamiento: []
  });

  tiposDivisorMuestra$: Observable<TipoDivisorMuestra[]>;
  tiposDivisorMuestraCheckItemList$: Observable<CheckItem[]>;
  tiposEquipamientoLaboratorioCheckItemList$: Observable<CheckItem[]>;
  tiposEquipamientoLaboratorio$: Observable<TipoEquipamientoLaboratorio[]>;
  tiposAnalisisLaboratorio$: Observable<TipoAnalisisLaboratorio[]>;
  especies$: Observable<Especie[]>;
  addOther = false;

  divisoresMuestraValid: boolean;
  divisoresMuestra: DivisorMuestra[];
  equiposValid: boolean;
  equipos: EquipamientoLaboratorio[];
  _equipamiento: Equipamiento;
  precisionOptions: number[] = [0, 1, 2, 3, 4];

  constructor(private fb: FormBuilder, private store: Store<State>) {}

  ngOnInit(): void {
    const ordenPersonalizado: { [key: string]: number } = {
      Pureza: 0,
      'Determinación de otras semillas en número': 1,
      'Determinación de Cuscuta spp.': 2,
      'Peso de 1.000 semillas': 3,
      Humedad: 4,
      'Poder germinativo': 5,
      'Viabilidad por Tetrazolio': 6
    };

    this.tiposAnalisisLaboratorio$ = this.store
      .select(selectAllTiposAnalisisLaboratorio)
      .pipe(
        map((tiposAnalisisLaboratorio) => {
          return tiposAnalisisLaboratorio.sort((a, b) => {
            const indexA = ordenPersonalizado[a.nombre];
            const indexB = ordenPersonalizado[b.nombre];

            if (indexA < indexB) {
              return -1;
            }
            if (indexA > indexB) {
              return 1;
            }

            return 0;
          });
        })
      );

    this.especies$ = this.store.select(selectAllEspecies).pipe(
      map((especies) =>
        especies.sort((a, b) => {
          if (
            a.nombre_cientifico.toLocaleLowerCase() <
            b.nombre_cientifico.toLocaleLowerCase()
          )
            return -1;
          if (
            a.nombre_cientifico.toLocaleLowerCase() >
            b.nombre_cientifico.toLocaleLowerCase()
          )
            return 1;
          return 0;
        })
      )
    );

    //this.agregarBalanza();
    //this.agregarGerminador();
    //this.agregarAnalisisEspecie();

    // emit events
    this.equipamientoFormGroup.valueChanges.subscribe((_) => {
      this.emitirEquipamientoLaboratorio();
    });

    this.equipamientoFormGroup.statusChanges.subscribe((s) => {
      this.emitirEquipamientoStatusLaboratorio();
    });
  }

  emitirEquipamientoLaboratorio() {
    let e: Equipamiento = createEmptyEquipamiento(); // EquipamientoLaboratorio
    e.balanzas = this.crearBalanzas();
    e.germinadores = this.crearGerminadores();
    e.analisis_especie = this.crearAnalisisEspecies();
    e.divisores_muestra = this.divisoresMuestra;
    e.equipamientos = this.equipos;
    this.formValueChanges.emit(e);
  }

  emitirEquipamientoStatusLaboratorio() {
    let status =
      this.equiposValid &&
      this.divisoresMuestraValid &&
      this.equipamientoFormGroup.valid
        ? 'VALID'
        : 'INVALID';
    this.formStatusChanges.emit(status);
  }

  //balanzas
  balanzas(): FormArray {
    return this.equipamientoFormGroup.get('balanzas') as FormArray;
  }

  nuevaBalanza(): FormGroup {
    return this.fb.group({
      id: [, []],
      precision: [, [Validators.required]],
      capacidad: [, [Validators.required, Validators.pattern(/^\d{1,4}$/)]]
    });
  }

  nuevaBalanzaParams(b: Balanza): FormGroup {
    const capacidadSinDecimales = parseInt(b.capacidad.toString());

    return this.fb.group({
      id: [b.id, []],
      precision: [b.precision, [Validators.required]],
      capacidad: [
        capacidadSinDecimales,
        [Validators.required, Validators.pattern(/^\d{1,4}$/)]
      ]
    });
  }

  agregarBalanza() {
    this.balanzas().push(this.nuevaBalanza());
  }

  eliminarBalanza(depIndex: number) {
    this.balanzas().removeAt(depIndex);
  }

  //germinadores
  germinadores(): FormArray {
    return this.equipamientoFormGroup.get('germinadores') as FormArray;
  }

  nuevoGerminador(): FormGroup {
    return this.fb.group({
      id: [, []],
      laboratorio_id: [, []],
      minima_temperatura: [
        ,
        [Validators.required, Validators.pattern(/^\d{1,3}$/)]
      ], //double(2)
      maxima_temperatura: [
        ,
        [Validators.required, Validators.pattern(/^\d{1,3}$/)]
      ], //double(2)
      tiene_alternancia_temperatura: [, []],
      tiene_alternancia_luz: [, []]
    });
  }

  nuevoGerminadorParams(g: Germinador): FormGroup {
    const minimaTemperaturaSinDecimales = parseInt(
      g.minima_temperatura.toString()
    );
    const maximaTemperaturaSinDecimales = parseInt(
      g.maxima_temperatura.toString()
    );

    return this.fb.group({
      id: [g.id, []],
      laboratorio_id: [g.laboratorio_id, []],
      minima_temperatura: [
        minimaTemperaturaSinDecimales,
        [Validators.required, Validators.pattern(/^\d{1,3}$/)]
      ], //double(2)
      maxima_temperatura: [
        maximaTemperaturaSinDecimales,
        [Validators.required, Validators.pattern(/^\d{1,3}$/)]
      ], //double(2)
      tiene_alternancia_temperatura: [g.tiene_alternancia_temperatura, []],
      tiene_alternancia_luz: [g.tiene_alternancia_luz, []]
    });
  }

  agregarGerminador() {
    this.germinadores().push(this.nuevoGerminador());
  }

  eliminarGerminador(depIndex: number) {
    this.germinadores().removeAt(depIndex);
  }

  // Analisis especies
  analisisEspecie(): FormArray {
    return this.equipamientoFormGroup.get('analisis_especie') as FormArray;
  }

  nuevoAnalisisEspecie(): FormGroup {
    return this.fb.group({
      id: [[], []],
      especie: [, [Validators.required]],
      analisis: [, [Validators.required]]
    });
  }

  nuevoAnalisisEspecieParams(ae: AuxFormAnalisisLaboratorioEspecie): FormGroup {
    return this.fb.group({
      id: [ae.id, []],
      especie: [ae.especie_id, [Validators.required]],
      analisis: [ae.tipo_analisis_laboratorio_id, [Validators.required]]
    });
  }

  agregarAnalisisEspecie() {
    this.analisisEspecie().push(this.nuevoAnalisisEspecie());
  }

  eliminarAnalisisEspecie(index: number) {
    this.analisisEspecie().removeAt(index);
  }

  // Divisores muestra
  divisoresMuestraStatusChange(s: string) {
    this.divisoresMuestraValid = s == 'VALID';
    this.emitirEquipamientoStatusLaboratorio();
  }

  divisoresMuestraChange(checkList: CheckItem[]) {
    this.divisoresMuestra = [];
    checkList.forEach((item) => {
      this.divisoresMuestra.push(
        createDivisorMuestra({
          id: item.id,
          laboratorio_id: null,
          tipo_divisor_muestra_id: item.tipo_id
        })
      );
    });
    this.emitirEquipamientoLaboratorio();
  }

  // Equipos o EquipamientoLaboratorio
  equiposStatusChange(s: string) {
    this.equiposValid = s == 'VALID';
    this.emitirEquipamientoStatusLaboratorio();
  }

  equiposChange(checkList: CheckItem[]) {
    this.equipos = [];
    checkList.forEach((item) => {
      if (item.id === -1) {
        this.equipos.push(
          createEquipamientoLaboratorio({
            id: null,
            nuevo_equipamiento: item.nombre
          })
        );
      } else {
        this.equipos.push(
          createEquipamientoLaboratorio({
            id: item.id,
            tipo_equipamiento_laboratorio_id: item.tipo_id
          })
        );
      }
    });
    this.emitirEquipamientoLaboratorio();
  }

  checkErrors(): void {
    this.equipamientoFormGroup.markAllAsTouched();
  }

  addOtherEquipamiento() {
    this.addOther = false;
    const nombreOther =
      this.equipamientoFormGroup.get('otherEquipamiento')?.value;
    this.equipamientoFormGroup.get('otherEquipamiento')?.setValue('');

    // conseguir elementos checkeados
    let elementosCheckeados: CheckItem[] = [];
    this.formInputEquiposLaboratorio.elementosCheck.forEach((e) => {
      if (
        this.equipos?.find(
          (equipo) => equipo.tipo_equipamiento_laboratorio_id == e.tipo_id
        )
      ) {
        elementosCheckeados.push({
          id: e.id,
          tipo_id: e.tipo_id,
          nombre: e.nombre,
          selected: true
        });
      } else {
        elementosCheckeados.push(e);
      }
    });
    const elementosCheck = [
      ...elementosCheckeados,
      {
        id: -1,
        tipo_id: -1,
        nombre: nombreOther,
        selected: true
      }
    ];
    const fe = createCheckListFormInput({
      elementosCheck: elementosCheck
    });
    this.formInputEquiposLaboratorio = fe;
  }

  crearBalanzas(): Balanza[] {
    let balanzas: Balanza[] = [];
    const bs = this.balanzas();
    bs.value.forEach((b: any) => {
      balanzas.push(
        createBalanza({
          id: b.id,
          laboratorio_id: b.laboratorio_id,
          capacidad: b.capacidad,
          precision: b.precision
        })
      );
    });
    return balanzas;
  }

  crearGerminadores(): Germinador[] {
    let germinadores: Germinador[] = [];
    const gs = this.germinadores();
    gs.value.forEach((g: any) => {
      germinadores.push(
        createGerminador({
          id: g.id,
          laboratorio_id: g.laboratorio_id,
          minima_temperatura: g.minima_temperatura,
          maxima_temperatura: g.maxima_temperatura,
          tiene_alternancia_temperatura: g.tiene_alternancia_temperatura,
          tiene_alternancia_luz: g.tiene_alternancia_luz
        })
      );
    });
    return germinadores;
  }

  crearAnalisisEspecies(): AnalisisLaboratorioEspecie[] {
    let analisisEspecie: AnalisisLaboratorioEspecie[] = [];
    const aes = this.analisisEspecie();
    if (aes?.value) {
      aes.value.forEach((ae: any) => {
        let count = 0;
        if (ae.analisis) {
          ae.analisis.forEach((a: number) => {
            analisisEspecie.push(
              createAnalisisLaboratorioEspecie({
                id: ae.id[count] ? ae.id[count] : null,
                laboratorio_id: ae.laboratorio_id ? ae.laboratorio_id : null,
                especie_id: ae.especie,
                tipo_analisis_laboratorio_id: a
              })
            );
            count = count + 1;
          });
        }
      });
    }
    return analisisEspecie;
  }

  setValues(e: Equipamiento) {
    if (e) {
      // Balanzas
      if (e.balanzas) {
        e.balanzas.forEach((b) => {
          const balanzaForm = this.nuevaBalanzaParams(b);
          this.balanzas().push(balanzaForm, { emitEvent: false });
        });
      } else {
        this.agregarBalanza();
      }
      //Germinadores
      if (e.germinadores) {
        e.germinadores.forEach((g) => {
          const germinadorForm = this.nuevoGerminadorParams(g);
          this.germinadores().push(germinadorForm, { emitEvent: false });
        });
      } else {
        this.agregarGerminador();
      }
      // Analisis especie
      if (e.analisis_especie) {
        let auxFormListALE: AuxFormAnalisisLaboratorioEspecie[] = [];
        e.analisis_especie.forEach((ae) => {
          const existeEspecie = auxFormListALE.find(
            (auxAE) => auxAE.especie_id == ae.especie_id
          );
          let analisisEspecie: AuxFormAnalisisLaboratorioEspecie;
          if (existeEspecie) {
            existeEspecie.id = [...existeEspecie.id, ae.id];
            existeEspecie.tipo_analisis_laboratorio_id = [
              ...existeEspecie.tipo_analisis_laboratorio_id,
              ae.tipo_analisis_laboratorio_id
            ];
          } else {
            analisisEspecie = {
              id: [ae.id],
              especie_id: ae.especie_id,
              tipo_analisis_laboratorio_id: [ae.tipo_analisis_laboratorio_id]
            };
            auxFormListALE.push(analisisEspecie);
          }
        });
        auxFormListALE.forEach((auxFLALE) => {
          const analisisEspecieForm = this.nuevoAnalisisEspecieParams(auxFLALE);
          this.analisisEspecie().push(analisisEspecieForm, {
            emitEvent: false
          });
        });
      } else {
        this.agregarAnalisisEspecie();
      }
    }
  }
}
